import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export function isSameStringIgnoreCase(str1, str2) {
    return str1 == str2 || (str1 && str2 && str1.toLowerCase() == str2.toLowerCase());
}
export function isSelf(address) {
    return (address &&
        isSameStringIgnoreCase(address.EmailAddress, getUserConfiguration().SessionSettings.UserEmailAddress));
}
//# sourceMappingURL=isSelf.js.map